/* Careers Jobs — client-side sort + filter
   Desktop: click a [data-sort-key] column header to sort (date default desc).
   Mobile:  <select data-filter-key> dropdowns filter by department / location.
   Both:    sort and filter compose — filter is applied after sort. */

(() => {
  document.querySelectorAll('.careers-jobs').forEach(section => {
    const tbody = section.querySelector('.careers-jobs__tbody');
    if (!tbody) return;

    const emptyState = section.querySelector('.careers-jobs__empty');
    const rows = [...tbody.querySelectorAll('.careers-jobs__tr--job')];
    const headers = [...section.querySelectorAll('[data-sort-key]')];
    const selects = [...section.querySelectorAll('.careers-jobs__filter-select')];

    let sortKey = 'date';
    let sortDir = 'desc';
    const activeFilters = {};

    // ── Mobile selects: populate options from row data ─────────────────
    selects.forEach(select => {
      const key = select.dataset.filterKey;
      const prop = `sort${key.charAt(0).toUpperCase()}${key.slice(1)}`;
      const values = [
        ...new Set(rows.map(r => r.dataset[prop]).filter(Boolean)),
      ].sort((a, b) => a.localeCompare(b));

      values.forEach(val => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        select.appendChild(opt);
      });

      select.addEventListener('change', () => {
        activeFilters[key] = select.value;
        render();
      });
    });

    // ── Column header sort ─────────────────────────────────────────────
    headers.forEach(th => {
      th.setAttribute('tabindex', '0');

      const handleSort = () => {
        const key = th.dataset.sortKey;
        if (sortKey === key) {
          sortDir = sortDir === 'asc' ? 'desc' : 'asc';
        } else {
          sortKey = key;
          sortDir = key === 'date' ? 'desc' : 'asc';
        }
        updateHeaders();
        render();
      };

      th.addEventListener('click', handleSort);
      th.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSort();
        }
      });
    });

    function updateHeaders() {
      headers.forEach(th => {
        const key = th.dataset.sortKey;
        const isActive = key === sortKey;
        th.classList.toggle('careers-jobs__th--active', isActive);
        th.classList.toggle('careers-jobs__th--asc', isActive && sortDir === 'asc');
        th.classList.toggle('careers-jobs__th--desc', isActive && sortDir === 'desc');
        th.setAttribute('aria-sort', isActive ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none');
      });
    }

    function parseDate(str) {
      if (!str) return 0;
      const d = new Date(str);
      return isNaN(d.getTime()) ? 0 : d.getTime();
    }

    function getSortValue(row) {
      if (sortKey === 'date') return parseDate(row.dataset.sortDate);
      const prop = `sort${sortKey.charAt(0).toUpperCase()}${sortKey.slice(1)}`;
      return (row.dataset[prop] || '').toLowerCase();
    }

    function sortRows(arr) {
      return [...arr].sort((a, b) => {
        const va = getSortValue(a);
        const vb = getSortValue(b);
        if (va < vb) return sortDir === 'asc' ? -1 : 1;
        if (va > vb) return sortDir === 'asc' ? 1 : -1;
        return 0;
      });
    }

    function filterRows(arr) {
      return arr.filter(row =>
        Object.entries(activeFilters).every(([key, val]) => {
          if (!val) return true;
          const prop = `sort${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          return (row.dataset[prop] || '').toLowerCase() === val.toLowerCase();
        })
      );
    }

    function render() {
      const visible = filterRows(sortRows(rows));
      rows.forEach(r => r.remove());
      visible.forEach(r => tbody.appendChild(r));
      if (emptyState) emptyState.hidden = visible.length > 0;
    }

    updateHeaders();
    render();
  });

  // ── Sync total job count into careers hero ─────────────────────────
  const totalJobs = document.querySelectorAll('.careers-jobs__tr--job').length;
  document.querySelectorAll('[data-jobs-count]').forEach(el => {
    el.textContent = el.textContent.replace(/\d+/, totalJobs);
  });
})();
